import { fmtDate, ftmPrice } from "../../extensions/utils";
import ClientPaymentChange from "./client-payment-change";

const ClientItemAbonPayment = ({ item, expanded, setExpanded, onClose }) => {
    
  const formattedDate = item.docDate?.format("DD.MM.YYYY")

  const handleHeaderClick = () => {
    setExpanded(!expanded);
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return<div className={!expanded ? "client-subitem" : "client-subitem-selected"}>
    <div className="client-item-body" onClick={() => handleHeaderClick}>
      <div className="client-item-line-bold-double">
        <div className="client-item-clip">{item.vid === 1 ? "Оплата" : item.vid === -1 ? "Возврат" : "???"} {fmtDate(item.saleDocDate)}</div>
        <div className="client-item-clip-right" style={item.vid === 1 ? {color:"green"} : item.vid === -1 ? {color:"red"} : {}}>{ftmPrice(item.syma)}</div>
      </div>
      <div className="client-item-line-triple-abon-payment">
        <div className="client-item-clip"># {item.id}</div>
        <div className="client-item-clip">Вид: {item.paymentVidName}</div>
        <div className="client-item-clip">Дата: {formattedDate}</div>
      </div>
    </div>
    {expanded && (
      <div onClick={stopPropagation}>
        <ClientPaymentChange paymentItem={item} onClose={() => onClose()} />
      </div>
    )}
  </div>
}

export default ClientItemAbonPayment;